import {ValidationErrors} from '@angular/forms';

export class ValidationErrorDescription implements ValidationErrors {
  constructor(public messageBase: string, public messageFn?: (valueFound: string, messageBase: string) => string) {}

  getValidationMessage(valueFound: any): string {
    return this.messageFn ? this.messageFn(valueFound, this.messageBase) : this.messageBase;
  }
}
